import type {
  BenefitItem,
  CouponItem,
  LedgerRow,
  MemberProfile,
  MemberStat,
  RewardItem,
} from "./types";

/** Client-side OTP input length for the member portal. */
export const OTP_LENGTH = 4;

export const memberProfile: MemberProfile = {
  name: "John Smith",
  memberId: "LM00012456",
  tier: "",
  status: "Active",
  joinedSince: "March 2022",
  avatarInitials: "JS",
  mobile: "9876543210",
  dob: "15 Aug 1992",
  doa: "22 Nov 2020",
  gender: "Male",
  city: "Mumbai",
  email: "john@example.com",
  memberSince: "2022",
  preferredStore: "Phoenix Mall",
  communication: "Email + SMS",
};

export const memberStats: MemberStat[] = [
  {
    id: "transactions",
    label: "Transactions",
    value: "128",
    subtitle: "Total Transactions",
    icon: "receipt",
  },
  {
    id: "spent",
    label: "Spent",
    value: "1,24,580",
    subtitle: "Lifetime Spend",
    icon: "wallet",
  },
  {
    id: "tier",
    label: "Tier",
    value: "",
    subtitle: "Current Tier",
    icon: "crown",
  },
  {
    id: "points",
    label: "Available Points",
    value: "8,450",
    subtitle: "Reward Points",
    icon: "gift",
  },
];

export const ledgerRows: LedgerRow[] = [
  {
    id: "1",
    counterId: "1",
    invoiceNo: "INV-1122",
    transactionType: "Earn",
    invoiceAmt: "2,100",
    pointsEarned: "210",
  },
  {
    id: "2",
    counterId: "1122",
    invoiceNo: "Inv0011",
    transactionType: "Earn",
    invoiceAmt: "1,000",
    pointsEarned: "—",
  },
];

export const rewards: RewardItem[] = [
  {
    id: "1",
    name: "Birthday Bonus",
    couponCode: "C37756",
    couponValue: "500",
    expiry: "Expires in 20 days",
  },
  {
    id: "2",
    name: "Shopping Rewards",
    couponCode: "C64871",
    couponValue: "500",
    expiry: "Never Expires",
  },
];

export const benefits: BenefitItem[] = [
  {
    id: "1",
    text: "1 Loyalty Point = 1 unit directly redeemable on future bills.",
    highlights: ["1 Loyalty Point = 1"],
  },
  {
    id: "2",
    text: "Minimum points threshold to start redemption is 100 points.",
    highlights: ["100 points"],
  },
  {
    id: "3",
    text: "Exclusive pre-access to seasonal fabric launch events and custom suiting discounts.",
  },
];

export const coupons: CouponItem[] = [
  {
    id: "1",
    title: "Welcome Offer",
    code: "WELCOME20",
    discount: "20% OFF",
    description: "Minimum purchase 1000",
    expiry: "Expires in 8 days",
    status: "ACTIVE",
  },
  {
    id: "2",
    title: "Save Offer",
    code: "SAVE500",
    discount: "500 OFF",
    description: "Purchase above 5000",
    expiry: "Expires in 15 days",
    status: "ACTIVE",
  },
];
